import * as React from 'react';
import Image from 'next/image';
import { BuildingOffice2Icon, MapPinIcon, UsersIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { customImageLoader } from '@restworld/utils-common';

export interface JobPositionsCardV2Props {
  jobTitle: string;
  businessName?: string;
  venueAddress?: string;
  openJobPositionsCount?: number;
  occupation?: string;
  restaurantLogoUrl?: string;
  restaurantHrefLink?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const InfoItem = ({
  InfoItemIcon,
  infoItemValue,
}: {
  InfoItemIcon: React.ElementType;
  infoItemValue?: string | number;
}) => (
  <div className="flex justify-start items-start gap-1">
    <InfoItemIcon className="h-4 w-4 relative text-neutral-90" />
    <h5 className="justify-start text-neutral-200 text-sm font-medium"> {infoItemValue}</h5>
  </div>
);

export function JobPositionsCardV2({
  jobTitle,
  businessName,
  venueAddress,
  openJobPositionsCount,
  occupation,
  restaurantLogoUrl = 'https://placehold.co/48x48?text=Logo',
  restaurantHrefLink,
  onClick,
}: JobPositionsCardV2Props) {
  return (
    <Link
      href={restaurantHrefLink || '#!'}
      className="self-stretch min-w-[288px] p-5 bg-neutral-10 rounded-2xl outline outline-1 outline-offset-[-1px] outline-neutral-40 inline-flex flex-col justify-start items-start"
      onClick={onClick}
    >
      <div className="self-stretch flex flex-col justify-start items-start">
        <div className="self-stretch pb-4 inline-flex justify-start items-center gap-2 flex-wrap content-center overflow-hidden">
          {!!restaurantLogoUrl && (
            <span className="w-8 h-8 relative">
              <Image
                fill
                alt="logo"
                className="rounded-lg border border-neutral-40 object-cover object-center"
                src={restaurantLogoUrl}
                loader={customImageLoader}
              />
            </span>
          )}
          <h5 className="flex-1 justify-center text-neutral-700 text-xl font-medium truncate">{jobTitle}</h5>
        </div>
        <div className="self-stretch pt-3 pb-6 inline-flex justify-start items-center gap-4 flex-wrap content-center">
          {!!businessName && <InfoItem InfoItemIcon={BuildingOffice2Icon} infoItemValue={businessName} />}
          {!!venueAddress && <InfoItem InfoItemIcon={MapPinIcon} infoItemValue={venueAddress} />}
          {!!occupation && <InfoItem InfoItemIcon={BuildingOffice2Icon} infoItemValue={occupation} />}
          {!!openJobPositionsCount && <InfoItem InfoItemIcon={UsersIcon} infoItemValue={openJobPositionsCount} />}
        </div>
      </div>
    </Link>
  );
}

export default JobPositionsCardV2;
